/** Maximum length of server-driven custom message (defense against oversized responses). */
export const MAINTENANCE_MESSAGE_MAX_LENGTH = 200;

/** Per-fetch timeout for probe + remote-flag calls. */
export const MAINTENANCE_FETCH_TIMEOUT_MS = 5_000;

/**
 * Clamp a server-driven message to MAINTENANCE_MESSAGE_MAX_LENGTH and coerce
 * non-strings to ''. Single source of truth shared by detector and remoteFlag.
 */
export function clampMessage(msg: unknown): string {
  if (typeof msg !== 'string') return '';
  return msg.slice(0, MAINTENANCE_MESSAGE_MAX_LENGTH);
}
